import React, { useState, useRef } from 'react';

export function clamp(n: number, min: number, max: number) {
  return Math.min(max, Math.max(min, n));
}

function easeOutCubic(t: number) {
  return 1 - Math.pow(1 - t, 3);
}

export function useAnimatedNumber(target: number, duration: number, decimals: number) {
  const [val, setVal] = useState(target);
  const rafRef = useRef<number | null>(null);
  const startRef = useRef<number | null>(null);
  const fromRef = useRef(target);

  React.useEffect(() => {
    if (!Number.isFinite(target)) return;
    fromRef.current = val;
    startRef.current = null;

    const step = (ts: number) => {
      if (startRef.current == null) startRef.current = ts;
      const p = Math.min(1, (ts - startRef.current) / duration);
      const eased = easeOutCubic(p);
      const next = fromRef.current + (target - fromRef.current) * eased;
      const k = Math.pow(10, decimals);
      setVal(Math.round(next * k) / k);
      if (p < 1) rafRef.current = requestAnimationFrame(step);
    };

    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(step);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [target, duration, decimals]);

  return val;
}
